import ModulesRepository from '@/shared/http/repositories/access/modulos'

export default {
  data () {
    return {
      modules: []
    }
  },

  async mounted () {
    this.modules = await this.getModules()
  },
  methods: {
    async getModules () {
      try {
        const response = await ModulesRepository.GetAll()
        return response.data
      } catch (error) {
        console.error('Error getting modules', error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins/modulesLite.js